import { useLocalize } from '@landsbankinn/l16n';
import {
  DD,
  DL,
  DLRow,
  DT,
  Flex,
  HeadingBar,
  Span,
} from '@landsbankinn/ui-kit';
import { type ScopeData } from '../../../state/server';
import { useConsentClientContext } from '../State/consentClientState';
import { formatData } from '../utils';

export function Group(props: { group: ScopeData[]; title: string }) {
  const { group, title } = props;
  const { locale } = useLocalize();
  const [consentClient] = useConsentClientContext();
  const tableData = group.filter((data) => data.type !== 'stringArray');

  return (
    <Flex direction="col" basis="318" grow="1">
      {!!title && (
        <HeadingBar color="blue font" marginTop="36">
          <Span fontVariant="h5">{title}</Span>
        </HeadingBar>
      )}

      <DL>
        {tableData.map((data, index) => {
          const label =
            consentClient.localization?.[data.name] ??
            data.localized_name ??
            data.name;

          return (
            <DLRow key={`${data.value}_${index}`}>
              <DT>{label}</DT>
              <DD>{data.format ? formatData(data, locale) : data.value}</DD>
            </DLRow>
          );
        })}
      </DL>
    </Flex>
  );
}
